addEventListener("DOMContentLoaded", (event) => {
  var banner = document.getElementById("cookie-banner");

  if (banner) {
    var cookie = getCookie("_acceptCookies");

    if (!cookie) {
      if (banner.classList.contains('closed'))
        banner.classList.remove('closed');
    }

    const acceptButton = banner.querySelector('[data-accept-cookies]');
    if (acceptButton) {
      acceptButton.addEventListener('click', function () {
        setCookie("_acceptCookies", "true");
      });
    }
  }
});

function setCookie(name, value) {
  document.cookie = name + "=" + (value || "") + "; path=/; max-age=" + (365 * 24 * 60 * 60);

  var banner = document.getElementById("cookie-banner");
  if (banner) {
    var cookie = getCookie("_acceptCookies");
    if (cookie) {
      if (!banner.classList.contains('closed'))
        banner.classList.add('closed');
    }
  }
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var cookie = ca[i];

    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1, cookie.length);
    }

    if (cookie.indexOf(nameEQ) == 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.setCookie = setCookie;
window.getCookie = getCookie;